import * as React from 'react';

export function Arrow({ className }: any) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M2 5.56L2.413 5h11.194l.393.54L8.373 11h-.827L2 5.56z" />
    </svg>
  );
}
